<script setup>
	import { onMounted } from 'vue';
	import { RouterView, useRouter } from 'vue-router'
	import { storeToRefs } from 'pinia'
	import { useStageStore } from './stores/stage';
	import Loader from './components/Loader.vue'
	import { useI18n } from 'vue-i18n';
	import useHelpers from './utils/helpers'

	const router = useRouter()
	const formStorage =  useStageStore()
	const { isLoading, answerId, answerToken } = storeToRefs(formStorage)
	const { hasAccess } = useHelpers()
    const { t } = useI18n()

	onMounted(() => {
		const app = document.getElementById('app_public')

		// Get dataset values
		if (app) {

			if (!!app.dataset?.previewMode?.length) {
				if (app.dataset.previewMode === 'true') {
					formStorage.setPreviewMode(true)

					// Listen to admin view router location changes
					window.addEventListener('router-url-changed', function(event) {
						console.log("public-view router-url-changed")
						console.log("event.detail", event.detail)

						const urlId = event.detail?.id
						if (urlId) {
							router.push(`/${urlId}`)
						}
					})
				}
			}

			if(!!app.dataset?.language?.length){
				formStorage.setLanguage(app.dataset.language);
			}

			// Survey Init Url
			if (!!app.dataset?.surveyAnswerUrl) {
				formStorage.setAnswerURL(app.dataset.surveyAnswerUrl);

				if(!!app.dataset.portletNameSpace){
					formStorage.setNameSpace(app.dataset.portletNameSpace);
				}

				if(!!app.dataset.surveyAnswerUuid) {
					formStorage.setSurveyAnswerUuid(app.dataset.surveyAnswerUuid);

					// Display form for entering survey password
					formStorage.showPasswordForm = true;
				} else {

					// Initialize survey
					formStorage.getSurveyFormData(app.dataset.surveyAnswerUrl);

					// Check access when requesting transition to stages
					const access = hasAccess(router.currentRoute.value.params.id)
					if (!access && !formStorage.previewMode) {
						router.push({ name: 'home' })
						return;
					}
				}
			}
		}
  })
</script>

<template>
	<template v-if="isLoading">
		<Loader />
	</template>
	<template v-else>
		<RouterView />
	</template>
</template>